import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=177f00c2&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=177f00c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177f00c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('177f00c2')) {
      api.createRecord('177f00c2', component.options)
    } else {
      api.reload('177f00c2', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=177f00c2&scoped=true&", function () {
      api.rerender('177f00c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ra4qKPI393ug/JS/comp/GuestBox.vue"
export default component.exports